// Customizable Area Start
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { IBlock } from "../../../framework/src/IBlock";
import { getStorageData, setStorageData } from "../../../framework/src/Utilities";
const mockData = require("./mock-data.json");
export const configJSON = require("./config.js");

export interface HasSuccessErrorType {
  isOpen: boolean;
  isSeverity: 'success' | 'info' | 'warning' | 'error';
  isMessage: string;
}
const TrialVisitSchedule: { [key: string]: string } = {
  "en": "Trial visit Schedule",
  "fr": "Calendrier des visites d'essai",
  "de": "Zeitplan für den Probebesuch",
  "es": "Horario de visita de prueba"
};
const TaskList: { [key: string]: string } = {
  "en": "Task List",
  "fr": "Liste des tâches",
  "de": "Aufgabenliste",
  "es": "Lista de tareas"
};
interface Task {
  id: number;
  task_name: string;
  description: string;
  study_id: number;
  milestone_id: number;
  created_at: string;
  updated_at: string;
  published: boolean;
  total_points: number | null;
  task_feedback: boolean;
}

interface UserData {
  id?: number; 
  full_name: string;
  email: string;
  quickblox_id: string | number;
  id_number: string | number;
  account_deactivated?: boolean;
}

interface AttendanceEntry {
  user_data: UserData;
  attended_task_lists: Task[];
  not_attended_task_lists: Task[];
  remaining_task_lists: Task[];
}

interface UnregisteredPatient {
  id_number: string | number | undefined;
  id: number;
  full_name: string;
  email: string;
  site_id: number;
}

interface InputData {
  attendance_data: AttendanceEntry[];
  unregistered_patients: UnregisteredPatient[];
}

interface Column {
  name: string;
  value: string;
}

interface RowData {
  [key: string]: string | number | undefined;
}
// Customizable Area End

export interface Props {
  // Customizable Area Start
  id: string;
  navigation: any;
  // Customizable Area End
}
interface S {
  // Customizable Area Start
  loading: boolean;
  language: string;
  token: string;
  showTextFieldSection: boolean;
  showSideDrawer: boolean;
  addPatientDrawerOpen: boolean;
  patientEmailError: boolean;
  emailErrorText: string;
  isLoader: boolean;
  patientEmailAddress: string;
  patientEmailAddressError: string;
  newConfirmPatientEmailAddress: string;
  newConfirmPatientEmailAddressError: string;
  patientErrorMsg: string;
  enrolmentDate:string;
  enrolmentDateError:string;
  patinetFullName: string;
  patinetFullNameError: string;
  patinetIdNumber: string;
  patinetIdNumberError: string;
  studyFullData: [{
    type: string;
    id: string;
    attributes: {
      account_id: number;
      study_name: string;
      study_description: string;
      study_number: string;
      archived: boolean;
      community: boolean;
      published: boolean;
      gamification: boolean;
      chat: boolean;
      milestone_managements: {
        data: {
          type: string;
          id: string;
          attributes: {
            name: string;
            id: number;
            end_date: string;
            start_date: string;
            milestone_description: string;
          };
        }
      };
      faq_managements: {
        data: {
          type: string;
          id: string;
          attributes: {
            id: number;
            answer: string;
            question: string;
            images: {
              url: string;
            };
            videos: {
              url: string;
            }
          };
        }
      };
    };
  }] | "",
  selectedStudy: any,
  selectedSiteID: number,
  emailScreen: boolean;
  nameScreen: boolean,
  postPatId: any,
  tabs: { label: string, value: string | number }[];
  selectedTab: string | number;
  tableData: {
    columns: { [name: string]: any }[];
    rows: { [key: string]: any }[];
  }
  rows: any;
  columnName: any;
  hasSuccessErrorForPatient: HasSuccessErrorType;
  // Customizable Area End
}
interface SS {
  id: any;
// Customizable Area Start
// Customizable Area End
}

export default class PatientController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  getStudyDataApiCallId: string = "";
  patchPatientRegAPIid: string = '';
  getPatientDataApiCallID: string = "";
  getPatientTasklistDataApiCallID: string = "";
  checkEmailValidationApiCallID:string="";
  getTrailVisitScheduleCallID:string="";
  // Customizable Area End
  
  constructor(props: Props) {
    // Customizable Area Start
    super(props);
    this.receive = this.receive.bind(this);
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage)
    ];

    this.state = {
      token: "",
      loading: false,
      enrolmentDate: new Date().toISOString().split("T")[0],
      enrolmentDateError:"",
      language: localStorage.getItem('language') || 'en',
      showTextFieldSection: true,
      showSideDrawer: false,
      addPatientDrawerOpen: false,
      patientEmailError: false,
      emailErrorText: '',
      isLoader: false,
      patientEmailAddress: '',
      patientEmailAddressError: '',
      newConfirmPatientEmailAddress: '',
      newConfirmPatientEmailAddressError: '',
      patinetFullName: '',
      patinetFullNameError: '',
      patinetIdNumber: '',
      patinetIdNumberError: '',
      studyFullData: '',
      selectedStudy: '',
      selectedSiteID: 0,
      emailScreen: true,
      nameScreen: false,
      patientErrorMsg: "",
      postPatId: '',
      tabs: [
        { label: "Trial Visit Schedule", value: "Trial Visit Schedule" },
        { label: "Task List", value: "Task List" }
      ],
      selectedTab: "Trial Visit Schedule",
      tableData: {
        columns: [],
        rows: []
      },
      rows: [],
      columnName: [],
      hasSuccessErrorForPatient: {
        isOpen: false,
        isSeverity: "success",
        isMessage: ""
      },
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End

  }

  async componentDidMount() {
    // Customizable Area Start
    super.componentDidMount();
    let studyNameStore = await getStorageData("studyName")
    let language = await getStorageData("language")
    let tab = [
      { label: "Trial Visit Schedule", value: TrialVisitSchedule[language || 'en'] },
      { label: "Task List", value: TaskList[language || 'en'] }
    ]
    this.setState({ language: language, tabs: tab })
    let parseData = JSON.parse(studyNameStore);
    const parsedStudyId = Number(parseData.id) || 0;
    const parsedSiteId = Number(parseData.attributes?.site_ids.data[0]?.id) || 0;
    this.setState({ selectedStudy: parsedStudyId, selectedSiteID: parsedSiteId });
    let patIdStore = await getStorageData("patId")
    this.getPatientDetails(patIdStore)
    this.callTrailVisitScheduleApi()
    // Customizable Area End
  }
  
  // Customizable Area Start
  async receive(from: string, message: Message) {

    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      let responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      if (apiRequestCallId != null) {
        // const study = responseJson.studies?.data?.[0];
        if (apiRequestCallId === this.getStudyDataApiCallId && responseJson) {
          this.setState({ studyFullData: responseJson.data });
        }
        // if (study) {
        //   const siteList = study.attributes?.site_ids?.data?.map((site: any) => ({
        //     id: Number(site.id),
        //     study_id: Number(study.id),
        //     name: site.attributes?.site_name,
        //     number: site.attributes?.site_number
        //   })) || [];
        
        //   this.setState({
        //     studyFullData: siteList,
        //   });
        // }
        else if (apiRequestCallId === this.patchPatientRegAPIid && responseJson) {
          this.handlePatchPatientDetails(responseJson);
        }
        else if (apiRequestCallId === this.getPatientDataApiCallID && responseJson) {
          console.log(responseJson, "res=========>");
        }
        else if (apiRequestCallId === this.getPatientTasklistDataApiCallID) {
          this.callResponceOfTasklist(responseJson?.data ?? responseJson);
        }else if(apiRequestCallId === this.checkEmailValidationApiCallID){
          this.callResponceEmailValidation(responseJson)
        }else if(apiRequestCallId === this.getTrailVisitScheduleCallID){      
          this.callResponceOfTrailVisitSchedule(responseJson?.data ?? responseJson);
        }

      }

    }

  }

  handleEnrolmentDate = (value: string) => {
    let error = "";
    const today = new Date().toISOString().split("T")[0];
  
    if (!value) {
      error = "Enrolment Date is required";
    } else if (value > today) {
      error = "Future date is not allowed";
    }
  
    this.setState({
      enrolmentDate: value,
      enrolmentDateError: error
    });
  };
  getPatientDisplayName = (user: UserData) => {
    if (user?.account_deactivated === false) {
      return `${user.full_name} (Inactive)`;
    }
    return user.full_name;
  };
  

  handlePatchPatientDetails = (responseJson: any) => {

    if (responseJson.data) {
      this.snackBarShowMessage(true, "success", "Patient Added Successfully");
      this.setState({ 
        tableData: { columns: [], rows: [] } 
      }, () => {
        this.callTrailVisitScheduleApi(); 
      });
      this.setState({
        nameScreen: false,
        emailScreen: true,
        patientEmailAddress:"",newConfirmPatientEmailAddress:"",patinetFullName:"",patinetIdNumber:"",patientErrorMsg:"",
        isLoader: false,
        addPatientDrawerOpen: false,
        enrolmentDate: new Date().toISOString().split("T")[0],
        enrolmentDateError: "",
        // selectedSiteID: 0,
      })
    };
    if (responseJson.meta.message) {
      this.snackBarShowMessage(true, "error", `${responseJson.meta.message}`)
      this.setState({
        patinetIdNumberError: `${responseJson.meta.message}`
      })
      return;
    }

    if (responseJson && responseJson.meta) {
      this.setState({
        patinetIdNumberError: responseJson.meta.errors,
      });
    }


  }

  snackBarShowMessage = (isOpen: boolean, isSeverity: 'success' | 'info' | 'warning' | 'error', isMessage: string) => {
    this.setState({
      hasSuccessErrorForPatient: {
        isOpen: isOpen,
        isSeverity: isSeverity,
        isMessage: isMessage
      }
    });
  };

  handleCloseSnack = () => {
    this.setState({
      hasSuccessErrorForPatient: {
        isOpen: false,
        isSeverity: "success",
        isMessage: ""
      }
    });
  };

  callResponceEmailValidation=(responseJson:any)=>{
    if (responseJson && responseJson.meta) {
      console.log("res1",responseJson)
      if(responseJson.meta.message === "New Patient to App"){
       
        this.setState({
          nameScreen: true,
          emailScreen: false,
          isLoader: false
        })
        setStorageData("patId", responseJson.data.id);
      }else if(responseJson.meta.message === "Patient already added in the selected study" ||
      responseJson.meta.message === "The patient is already registered in another site" || responseJson.meta.message === "The patient is already registered.")
        {
  this.setState({
    patientEmailError: true,
    patientEmailAddressError: responseJson.meta.message,
    isLoader: false
  });
}else if(responseJson.meta.message === "Patient already registred in site you can continue to register to current study")
      {  
        this.setState({
          nameScreen: true,
          emailScreen: false,
          isLoader: false,
          patinetFullName:responseJson.meta.patient.data.attributes.full_name
        })
        setStorageData("patId", responseJson.data.id);
      }
     
    }

    if (responseJson.patient) {
      this.setState({
        nameScreen: true,
        emailScreen: false,
        isLoader: false,
        patinetFullName:responseJson.patient.data.attributes.full_name
      })
      setStorageData("patId", responseJson.data.id);
    }
  }
  
  callResponceOfTasklist = (data: InputData) => {
  localStorage.setItem("patientData", JSON.stringify(data));

  const taskNames: Column[] = [
    { name: "Patient Name", value: "" },
    { name: "ID", value: "" },
  ]; 

  data.attendance_data.forEach((item) => {
    (['attended_task_lists', 'not_attended_task_lists', 'remaining_task_lists'] as (keyof AttendanceEntry)[])
  .forEach((key) => {
    const taskList = item[key] as Task[]; 
    taskList.forEach((task: Task) => {
      const existingTask = taskNames.find(t => t.value === task.task_name);
      if (!existingTask) {
        taskNames.push({ name: `T${(taskNames.length - 2) + 1}`, value: task.task_name });
      }
    });
  });
  });

  this.setState({ columnName: taskNames });

  const rows: RowData[] = [];

  data.attendance_data.forEach((item) => {
    const rowData: RowData = {
      'Patient Name': this.getPatientDisplayName(item.user_data),
      'ID': item.user_data.id_number,
      'quickBlox': item.user_data.quickblox_id
    };

    item.attended_task_lists.forEach((task, index) => {
      const columnName = `T${index + 1}`;
      rowData[columnName] = "Attended";
    });

    item.not_attended_task_lists.forEach((task, index) => {
      const columnName = `T${item.attended_task_lists.length + index + 1}`;
      rowData[columnName] = "Not Attended";
    });

    item.remaining_task_lists.forEach((task, index) => {
      const columnName = `T${item.attended_task_lists.length + item.not_attended_task_lists.length + index + 1}`;
      rowData[columnName] = "Remaining";
    });

    rows.push(rowData);
  });

  data.unregistered_patients.forEach((item) => {
    const rowData: RowData = {
      'Patient Name': `${item.full_name} (Unregistered)`,
      'ID': item.id_number,
      
    };
    rows.push(rowData);
  });

  const tableData = {
    columns: taskNames,
    rows: rows
  };

  this.setState({ tableData: { ...tableData, rows: [...tableData.rows], columns: [...tableData.columns] } }, () => {
  });
};
  callResponceOfTrailVisitSchedule = (data1: any) => {
    
    localStorage.setItem("patientData", JSON.stringify(data1));
  
    const taskNames1: any[] = [
      { name: "Patient Name", value: "" },
      { name: "ID", value: "" },
    ];
  
    // Track the maximum number of columns needed
    let maxColumns = 0; 
    data1.attendance_data.
    forEach((item: { [x: string]: any[] }) => {     
      const attendedLength = item.attended_schedules.length;
      const notAttendedLength = item.not_attended_schedules.length;
      const remainingLength = item.remaining_schedules.length;
  
      // Calculate the total number of unique tasks
      const totalTasks = attendedLength + notAttendedLength + remainingLength;      
      if (totalTasks > maxColumns) {
        maxColumns = totalTasks;
      }
    });
  
    // Generate column names based on the maximum number of tasks 
    for (let i = 1; i <= maxColumns; i++) {
      taskNames1.push({ name: `V${i}` });
    }
  
    this.setState({ columnName: taskNames1 });
    const rows: any = []; 
   
    data1.attendance_data
    .forEach((item: { user_data: { full_name: any; id_number: any; email: string; quickblox_id: string; }; attended_schedules: any[]; not_attended_schedules: any[]; remaining_schedules: any[]; }) => {
      type RowData = {
        [key: string]: any;
      };
  
      const rowData: RowData = {
        'Patient Name': this.getPatientDisplayName(item.user_data),
        'ID': item.user_data.id_number,
        'quickBlox': item?.user_data?.quickblox_id
      };
  
      item.attended_schedules.forEach((task: any, index: number) => {
        const columnName = `V${index + 1}`;
        rowData[columnName] = "Attended";
      });
  
      item.not_attended_schedules.forEach((task: any, index: number) => {
        const columnName = `V${item.attended_schedules.length + index + 1}`;
        rowData[columnName] = "Not Attended";
      });
  
      item.remaining_schedules.forEach((task: any, index: number) => {
        const columnName = `V${item.attended_schedules.length + item.not_attended_schedules.length + index + 1}`;
        rowData[columnName] = "Remaining";
      });
  
      rows.push(rowData);
    });
  
    data1.unregistered_patients
    .forEach((item: {
      id_number: any;email:string,full_name:string,id:any,site_id:any
}) => {
      type RowData = {
        [key: string]: any;
      };
  
      const rowData: RowData = {
        'Patient Name': item.full_name+" (Unregistered)",
        'ID': item.id_number      
      };
      rows.push(rowData);
    });

    const tableData = {
      "columns": taskNames1,
      "rows": rows
    };
  
    this.setState({ tableData: tableData });
  }; 
  
  handleAddPatientDetails = (responseJson: any) => {
    if (responseJson && responseJson.meta) {
      this.setState({
        patientEmailError: true,
        patientEmailAddressError: responseJson.meta.message,
        isLoader: false
      });
    }

    if (responseJson.data) {
      this.setState({
        nameScreen: true,
        emailScreen: false,
        isLoader: false
      })
      setStorageData("patId", responseJson.data.id);
    }
  }

  handlePatientEmailAddress = (value: any) => {
    const strongEmailRegex = configJSON.emailRegex;
    this.setState({
      patientEmailAddress: value,
      patientEmailAddressError: strongEmailRegex.test(value)
        ? ""
        : "Email must be valid",
      patientErrorMsg: ''
    })
  }

  handleNewConfirmPatientEmailAddress = (value: any) => {
    this.setState({
      newConfirmPatientEmailAddress: value,
      newConfirmPatientEmailAddressError: this.state.patientEmailAddress === value ? "" : 'Email does not match'
    })
  }

  handleContinueButton = () => {
    const { patientEmailAddress, newConfirmPatientEmailAddress } = this.state;
    if (!patientEmailAddress && !newConfirmPatientEmailAddress) {
      this.setState({ patientEmailAddressError: 'Email is required', newConfirmPatientEmailAddressError: 'Confirm Email is required', patientErrorMsg: "" });
    } else if (patientEmailAddress !== newConfirmPatientEmailAddress) {
      this.setState({ newConfirmPatientEmailAddressError: 'Email does not match' });
    }
    else {
      {
        this.callCheckEmailApi();
        this.setState({
          isLoader: true,
        });
      }
    }
  }
  callCheckEmailApi=()=>{
    let token = localStorage.getItem("token")
   

    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.patientEmailValidation+'?email='+this.state.patientEmailAddress+'&role_name='+"Patient"+'&site_id='+this.state.selectedSiteID+'&study_ids='+this.state.selectedStudy+''
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.dashboarApiMethodType
    );
   
    this.checkEmailValidationApiCallID = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
//   handleAddPatientButton = () => {
//     let hasError = false;
//     if (this.state.patinetFullName.trim() === "") {
//         this.setState({ patinetFullNameError: "Full Name is required" });
//         hasError = true;
//     } else {
//         this.setState({ patinetFullNameError: "" });
//     }
  
//     if (this.state.patinetIdNumber === "") {
//         this.setState({ patinetIdNumberError: "Id is required" });
//         hasError = true;
//     } else {
//         this.setState({ patinetIdNumberError: "" });
//     }
  
//     if (!hasError) {
//         this.patchPatientRegistration();
//     }
// }
handleAddPatientButton = () => {
  let hasError = false;

  // Full Name optional
  if (
    this.state.patinetFullName &&
    this.state.patinetFullName.trim() !== "" &&
    this.state.patinetFullNameError !== ""
  ) {
    hasError = true;
  }

  if (this.state.patinetIdNumber.trim() === "") {
    this.setState({ patinetIdNumberError: "Id is required" });
    hasError = true;
  } else {
    this.setState({ patinetIdNumberError: "" });
  }

  if (this.state.enrolmentDate.trim() === "") {
    this.setState({ enrolmentDateError: "Enrolment Date is required" });
    hasError = true;
  }

  if (!hasError) {
    this.patchPatientRegistration();
  }
};
handlePatientFullName = (value: any) => {
  const strongNameRegex = configJSON.nameRegex;
  const trimmedValue = value.trim();
  if (trimmedValue === "") {
    this.setState({
      patinetFullName: value,
      patinetFullNameError: ""
    });
    return;
  }

  const isLengthValid =
  trimmedValue.length > 2 && trimmedValue.length < 20;

  this.setState({
    patinetFullName: value,
    patinetFullNameError:
      strongNameRegex.test(trimmedValue) && isLengthValid
        ? ""
        : "Please enter a valid name"
  });
};

  handlePatientIdNumber = (value: any) => {    
    const sanitizedValue = value.replace(/[^a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '').slice(0, 10);  
    const strongIdRegex = configJSON.idRegex;
    const isLengthValid = sanitizedValue.length >= 3 && sanitizedValue.length <= 10;
    const isFormatValid = strongIdRegex.test(sanitizedValue);  
    this.setState({
      patinetIdNumber: sanitizedValue,
      patinetIdNumberError: isFormatValid && isLengthValid
        ? ""
        : "Please enter a valid ID between 3 and 10 characters"
    });
  };
  

handleLanguageSwitch = (language: string) => {
  localStorage.setItem("language", language)
  let tab = [
    { label: "Trial Visit Schedule", value: TrialVisitSchedule[language || 'en'] },
    { label: "Task List", value: TaskList[language || 'en'] }
  ]
  this.setState({ language: language, tabs : tab})
}
// handleAddPatDrawerOpen = () => {
//   this.getStudyDataIndexDetail();
  
//   this.setState({
//     selectedSiteID: 0,
//   });

//   setTimeout(() => {
//     this.setState({ addPatientDrawerOpen: true });
//   }, 200);
// };
handleAddPatDrawerOpen = () => {
  this.getStudyDataIndexDetail()
  this.setState({ addPatientDrawerOpen: !this.state.addPatientDrawerOpen, });
};

  handleCloseCancel = () => {
    if (this.state.emailScreen) {
      this.setState({
        addPatientDrawerOpen: false,
        patientEmailAddress: "",
        newConfirmPatientEmailAddress: "",
        patientEmailAddressError: "",
        newConfirmPatientEmailAddressError: "",
        isLoader: false,
        enrolmentDate: new Date().toISOString().split("T")[0],
        enrolmentDateError: "",
      });
    } else {
      this.setState({
        addPatientDrawerOpen: false,
        emailScreen: true,
        nameScreen: false,
        showTextFieldSection: true,
        patientEmailAddress: "",
        newConfirmPatientEmailAddress: "",
        patinetFullName: "",
        patinetIdNumber: "",
        patientEmailAddressError: "",
        newConfirmPatientEmailAddressError: "",
        patinetFullNameError: "",
        patinetIdNumberError: "",
        patientErrorMsg: "",
        isLoader: false,
        enrolmentDate: new Date().toISOString().split("T")[0],
      enrolmentDateError: "",
      });
    }
  };
  
  handleDrawerCloseAdd = () => {
    this.setState({
      addPatientDrawerOpen: false,
      patientEmailAddressError: '', newConfirmPatientEmailAddressError: '', patinetFullNameError: '', patinetIdNumberError: '', isLoader: false
    });
  };

  handleEdit = () => {
    this.setState({
      nameScreen: false, emailScreen: true
    })
  }
  callTrailVisitScheduleApi=async()=>{
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };
    const selectedStudyId = Number(this.state.selectedStudy);

  if (!selectedStudyId) {
    console.warn("Study ID missing, API not called");
    return;
  }
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getVisitScheduleAPiEndPoint}/${selectedStudyId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.dashboarApiMethodType
    );
    this.getTrailVisitScheduleCallID = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  getAllTasklist = async() => {
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };
    const selectedStudyId = Number(this.state.selectedStudy);
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getTasklistAPiEndPoint}/${selectedStudyId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.dashboarApiMethodType
    );
    this.getPatientTasklistDataApiCallID = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  getPatientDetails = async (id: number) => {
    if (!id) {
      return
    }
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getPatientApiEndPoint}/${id}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.dashboarApiMethodType
    );
    this.getPatientDataApiCallID = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getStudyDataIndexDetail = async () => {
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };
    const selectedStudyId = Number(this.state.selectedStudy);
    console.log(selectedStudyId,"selectedStudyId")
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getStudiesApiEndPoint}/${selectedStudyId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.dashboarApiMethodType
    );
    this.getStudyDataApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  patchPatientRegistration = async () => {
    setStorageData("full_name", this.state.patinetFullName)
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };

    let formDataCampaignUpdate = {
      "email": this.state.patientEmailAddress.toLowerCase(),
      "role_name": "Patient",
      "site_id": this.state.selectedSiteID,  
      "study_ids": Number(this.state.selectedStudy),
      "full_name": this.state.patinetFullName,
      "id_number": this.state.patinetIdNumber,
      "enrolment_date": this.state.enrolmentDate,
    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.addPatientRegistrationAPiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeAddDetail
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(formDataCampaignUpdate)
    );
    this.patchPatientRegAPIid = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleSelectTab = (value: string | number) => {
    this.setState({ selectedTab: value });
    if (value === TrialVisitSchedule[this.state.language || 'en']) {
      this.setState({tableData: {
        columns: [],
        rows: []
      }})
      this.callTrailVisitScheduleApi();
    } else {
      this.setState({tableData: {
        columns: [],
        rows: []
      }})
      this.getAllTasklist()
    }
  }
  // Customizable Area End
}
// Customizable Area Start
// Customizable Area End